import React from "react"
import "./styles.css"

type CheckboxProps = {
  name: string
  setState: React.Dispatch<React.SetStateAction<any>>
  state: any
  id: string
  label: React.ReactNode
}

export const Checkbox: React.FC<CheckboxProps> = ({
  name,
  setState,
  state,
  id,
  label,
}) => {
  const inputId = `input-checkbox-${id}`

  return (
    <div className="m-1">
      <div style={{ display: "flex", alignItems: "center", gap: 2, height: "20px"}}>
        <input
          type="checkbox"
          className={`checkbox ${state[name] ? "text-success" : "text-danger"}`}
          id={inputId}
          checked={state[name] || false}
          onChange={(e) =>
            setState({ ...state, [name]: e.target.checked })
          }
        />

        <label
          htmlFor={inputId}
          id={"labelText"}
          style={{
            fontSize: 12,
            fontWeight: "bold",
            color: "#332E1A",
            margin: 0,
            cursor: "pointer",
          }}
        >
          {label}
        </label>
        <div
          style={{
            fontSize: 12,
            fontWeight: "bold",
            color: state[name] ? "#30A151" : "#FA2B62",
            marginTop: 0,
          }}
          id="confirm"
        >
          {state[name] ? "SIM" : "NÃO"}
        </div>
      </div>


    </div>
  )
}